var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolbox-color",on:{"click":_vm.setCanvasToolColor}},[_c('div',{staticClass:"inner-color",style:('background-color:' + _vm.boxCanvasToolColor)})])
}
var staticRenderFns = []

export { render, staticRenderFns }